module.exports = __webpack_public_path__ + "static/img/ME.f322307b.png";